<template>
    <!-- 帮助与支持 -->
    <div class="help">
        <div class="container container-lg">
            <div class="row justify-content-center">
                <div class="col-lg-12">
                    <div class="row row-grid justify-content-center">
                        <div class="col-lg-5">
                            <!-- <router-link to="/help/1"> -->
                                <card class="border-0 " shadow body-classes="py-3">
                                    <div class="d-flex flex-column align-items-center">
                                        <img width="100" src="/img/pay/0--21.png" alt="">
                                        <h6 class="text-primary text-uppercase">{{ $t('help.title1') }}</h6>
                                        <p class="description mt-3">{{ $t('help.desc1') }}</p>
                                    </div>
                                </card>
                            <!-- </router-link> -->
                        </div>
                        <div class="col-lg-5">
                            <!-- <router-link to="/help/2"> -->
                                <card class="border-0" shadow body-classes="py-3">
                                    <div class="d-flex flex-column align-items-center">
                                       <img width="100" src="/img/pay/0-_icon-13.png" alt="">
                                        <h6 class="text-success text-uppercase">{{ $t('help.title2') }}</h6>
                                        <p class="description mt-3">{{ $t('help.desc2') }}</p>
                                    </div>
                                </card>
                            <!-- </router-link> -->
                        </div>
                    </div>
                    <div class="row row-grid justify-content-center">
                        <div class="col-lg-5">
                            <!-- <router-link to="/help/3"> -->
                                <card class="border-0" shadow body-classes="py-3">
                                    <div class="d-flex flex-column align-items-center">
                                       <img width="100" src="/img/pay/0-_icon-14.png" alt="">
                                        <h6 class="text-warning text-uppercase">{{ $t('help.title3') }}</h6>
                                        <p class="description mt-3">{{ $t('help.desc3') }}</p>
                                    </div>
                                </card>
                            <!-- </router-link> -->
                        </div>
                        <div class="col-lg-5">
                            <!-- <router-link to="/help/4"> -->
                                <card class="border-0" shadow body-classes="py-3">
                                    <div class="d-flex flex-column align-items-center">
                                        <img width="100" src="/img/pay/0-_icon-17.png" alt="">
                                        <h6 class="text-info text-uppercase">{{ $t('help.title4') }}</h6>
                                        <p class="description mt-3">{{ $t('help.desc4') }}</p>
                                    </div>
                                </card>
                            <!-- </router-link> -->
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'help',
    data() {
        return {

        }
    }
}
</script>
<style lang="scss" scoped>
.help {
    background-image: url('/img/pay/0-_BG-3.png');
    background-size: cover;
    background-position: bottom;
    background-repeat: no-repeat;
    height: var(--main-height);
    padding-top: 68px;
}

.container {
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    .row {
        width: 100%;
    }

    .row-grid+.row-grid {
        margin-top: 2rem;
    }
}
</style>
